<template>
    <button
        type="button"
        @click="toggle"
        :class="['hamburgerToggle', { '-active': isActive }]"
    >
        <span class="hamburgerToggle__line"></span>
        <span class="hamburgerToggle__line"></span>
        <span class="hamburgerToggle__line"></span>
        <div class="sr-only">{{ isActive ? 'Close Menu' : 'Open Menu' }}</div>
    </button>
</template>

<script>
export default {
    props: {
        isActive: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        toggle() {
            this.$emit("toggle");
        },
    },
};
</script>

<style lang="scss">

</style>
